<template>
  <div class="flex mt-2 h-6 w-32 mb-2 shimmer-box duration-400 animate-pulse rounded-md" >
   <div class="w-6 h-6 ml-1" >

   </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>

.shimmer-box {
  background: rgba(255, 255, 255, 0.1);

}
</style>
